import React from 'react'
import { Line } from 'react-chartjs-2';
import { grey } from "@material-ui/core/colors";

function TimeLineGraph({ wirate_timeline, teamRadiant, teamDire }) {
  const options = {
    legend: {
      display: true,
      labels: {
        fontSize: 13,
        fontColor: 'white',
      },
    },
    title: {
      display: true,
      text: 'График вероятности победы относительно времени',
      fontSize: 15,
      fontColor: 'white', // Заголовок графика
    },
    responsive: true,
    scales: {
      xAxes: [
        {
          ticks: {
            fontColor: 'white',
            fontSize: 13,
            fontStyle: 'bold',
          },
          gridLines: {
            color: grey['A700'],
          },
          scaleLabel: {
            display: true,
            labelString: 'Время матча, мин.',
            fontSize: 13,
            fontColor: grey[300],
          }
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: grey[300],
            fontSize: 13,
            suggestedMin: Math.min(...wirate_timeline.datasets.reduce((prev, curr) => [...prev, ...curr.data], [])),
            suggestedMax: Math.max(...wirate_timeline.datasets.reduce((prev, curr) => [...prev, ...curr.data], [])),
          },
          gridLines: {
            color: grey['A700'],
          },
          scaleLabel: {
            display: true,
            labelString: 'Вероятность победы, %',
            fontSize: 13,
            fontColor: grey[300],
          }
        },
      ],
    },
  }

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <Line data={wirate_timeline} options={options} />
    </div>
  )
}

export default TimeLineGraph;